import React from 'react';
import SingleLeavesBreadcrumbs from 'domain/people/leave/shared/SingleLeavesBreadcrumbs';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdateLeaveBreadcrumbs = () => {
  return (
    <SingleLeavesBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleLeavesBreadcrumbs>
  );
};

export default UpdateLeaveBreadcrumbs;
